import { graphql } from "@acto/gql";
import { useQuery } from "urql";
import { useMemo } from "react";

const MeetingsCountQuery = graphql(`
  query GetMeetingsCount($filter: MeetingCountFilter) {
    meetingsCount(filter: $filter)
  }
`);

interface MeetingCountFilterOptions {
  scheduledDate?: string;
  hasNote?: boolean;
}

export interface UseMeetingsCountResult {
  data: number | undefined;
  isFetching: boolean;
  isPending: boolean;
  error: Error | undefined;
  refetch: () => void;
}

export function useMeetingsCount(filter?: MeetingCountFilterOptions): UseMeetingsCountResult {
  const variables = useMemo(
    () => ({
      filter: filter
        ? {
            scheduledDate: filter.scheduledDate,
            hasNote: filter.hasNote,
          }
        : undefined,
    }),
    [filter?.scheduledDate, filter?.hasNote],
  );

  const [result, reexecuteQuery] = useQuery({
    query: MeetingsCountQuery,
    variables,
    requestPolicy: "cache-first",
  });

  const { data, fetching: isFetching, error } = result;
  const isPending = !data && isFetching;

  return {
    data: data?.meetingsCount,
    isFetching,
    isPending,
    error,
    refetch: () => reexecuteQuery({ requestPolicy: "network-only" }),
  };
}
